import * as Utils from 'Assets/Utils'

import ClientHttpRequest from "Api/ClientHttpRequest"
import Immutable from 'immutable'
import {createModal} from 'Modules/Modal'
import {isLoading} from "Modules/Loading"

const initialState = Immutable.Map({})
  .set('Perfil', new Immutable.List([]))
  .set('PersonalInterno', new Immutable.List([]))
  .set('tipoBitacora', new Immutable.List([]))
  .set('Bitacora', new Immutable.List([]))
  .set('Get', new Immutable.Map({}))

/* Types */
export const ACTION_SEARCH_CONSULTA_PERFIL = 'ACTION_SEARCH_CONSULTA_PERFIL'
export const ACTION_SEARCH_CONSULTA_PERSONAL_INTERNO = 'ACTION_SEARCH_CONSULTA_PERSONAL_INTERNO'
export const ACTION_SEARCH_CONSULTA_TIPO_BITACORA = 'ACTION_SEARCH_CONSULTA_TIPO_BITACORA'
export const ACTION_SEARCH_CONSULTA_BITACORA = 'ACTION_SEARCH_CONSULTA_BITACORA'
export const ACTION_GET_BITACORA = 'ACTION_GET_BITACORA'

/* Reducer */
export default (state = initialState, action) => {

  switch (action.type) {

    case ACTION_SEARCH_CONSULTA_PERFIL:
      return state.set('Perfil', new Immutable.List(action.Obj))
    case ACTION_SEARCH_CONSULTA_PERSONAL_INTERNO:
      return state.set('PersonalInterno', new Immutable.List(action.Obj))
    case ACTION_SEARCH_CONSULTA_TIPO_BITACORA:
      return state.set('tipoBitacora', new Immutable.List(action.Obj))
    case ACTION_SEARCH_CONSULTA_BITACORA:
      return state.set('Bitacora', new Immutable.List(action.Obj))
    case ACTION_GET_BITACORA:
      return state.set('Get', new Immutable.Map(action.Obj))
    default:
      return state;
  }
};

/* Action Creators */

export const getConsultaPerfil = (idTipoPerfil) => {
  return (dispatch) => {

    dispatch(isLoading(true))

    return new ClientHttpRequest({
      service: 'api/getConsultaPerfil',
      method: "POST",
      data: {idTipoPerfil},
      headers: Object.assign({"Authorization": sessionStorage.access_token, "uid": sessionStorage.uid})
    }).request().then((response) => {
      dispatch(isLoading(false))
      dispatch({type: ACTION_SEARCH_CONSULTA_PERFIL, Obj: response.data})
    }).catch(error => {
      dispatch(isLoading(false))
      dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
      throw error
    })
  }
}

export const getConsultaPersonalInterno = () => {
  return (dispatch) => {

    dispatch(isLoading(true))

    return new ClientHttpRequest({
      service: 'api/getConsultaPersonalInterno',
      method: "POST",
      data: {},
      headers: Object.assign({"Authorization": sessionStorage.access_token, "uid": sessionStorage.uid})
    }).request().then((response) => {
      dispatch(isLoading(false))
      dispatch({type: ACTION_SEARCH_CONSULTA_PERSONAL_INTERNO, Obj: response.data})
    }).catch(error => {
      dispatch(isLoading(false))
      dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
      throw error
    })
  }
}

export const getConsultaTipoBitacora = () => {
  return (dispatch) => {
    dispatch(isLoading(true))
    return new ClientHttpRequest({
      service: 'api/getConsultaTipoBitacora',
      method: "POST",
      data: {},
      headers: Object.assign({"Authorization": sessionStorage.access_token, "uid": sessionStorage.uid})
    }).request().then((response) => {
      dispatch(isLoading(false))
      dispatch({type: ACTION_SEARCH_CONSULTA_TIPO_BITACORA, Obj: response.data})
    }).catch(error => {
      dispatch(isLoading(false))
      dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
      throw error
    })
  }
}

export const getConsultaBitacora = (form) => {

  return (dispatch) => {
    dispatch(isLoading(true))
    return new ClientHttpRequest({
      service: 'api/getConsultaBitacora',
      method: "POST",
      data: {...form},
      headers: Object.assign({"Authorization": sessionStorage.access_token, "uid": sessionStorage.uid})
    }).request().then((response) => {
      dispatch(isLoading(false))
      dispatch({type: ACTION_SEARCH_CONSULTA_BITACORA, Obj: response.data})
    }).catch(error => {
      dispatch(isLoading(false))
      dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
      throw error
    })
  }
}

export const agregaBitacora = (form) => {

  let aux = []
  let tipos = form.idTipo.split(",")
  tipos.map(tipo => {
    let auxAs = {id: parseInt(tipo)}
    aux.push(auxAs)
  })
  tipos = aux
  let temp = {
    nombre: form.nombre,
    fechaCreacion: form.fecha,
    tipos: tipos,
    asistentes: form.asistentes,
    tema: form.tema,
    acuerdo: form.acuerdo,
    fechaCompromiso: form.fechaCompromiso,
    usuario: sessionStorage.uid
  }

  if (form.idBitacora) {
    temp.idBitacora = form.idBitacora
  } else {
    temp.idCatalogoPerfil = form.itemSelected.idCatalogoPerfil
    temp.idTipoPerfil = form.radioSelected
  }

  return (dispatch) => {
    dispatch(isLoading(true))
    return new ClientHttpRequest({
      service: form.idBitacora ? 'api/editarBitacora' : 'api/agregaBitacora',
      method: "POST",
      data: {...temp},
      headers: Object.assign({"Authorization": sessionStorage.access_token, "uid": sessionStorage.uid})
    }).request().then((response) => {
      dispatch(isLoading(false))
      dispatch({type: ACTION_GET_BITACORA, Obj: response.data})
      return response.data
    }).catch(error => {
      dispatch(isLoading(false))
      dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
      throw error
    })
  }
}

export const eliminaBitacora = (idBitacora) => {
  let temp = {
    idBitacora: idBitacora,
    usuario: sessionStorage.uid
  }
  return (dispatch) => {
    dispatch(isLoading(true))
    return new ClientHttpRequest({
      service: 'api/eliminaBitacora',
      method: "POST",
      data: {...temp},
      headers: Object.assign({"Authorization": sessionStorage.access_token, "uid": sessionStorage.uid})
    }).request().then((response) => {
      dispatch(isLoading(false))
      return response.data
    }).catch(error => {
      dispatch(isLoading(false))
      dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
      throw error
    })
  }

}

export const eliminaDocumentos = (idDocumento) => {

  return (dispatch) => {

    dispatch(isLoading(true))

    return new ClientHttpRequest({
      service: 'api/eliminaDocumentos',
      method: "POST",
      data: {idDocumento},
      headers: Object.assign({"Authorization": sessionStorage.access_token, "uid": sessionStorage.uid})
    }).request().then((response) => {
      dispatch(isLoading(false))
      return response.data
    }).catch(error => {
      dispatch(isLoading(false))
      dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
      throw error
    })
  }
}

export const informarBitGen = (form) => {
  let informe = form.informar.split(',').map((item) => {
    return {idUsuario: item}
  })
  let temp = {
    bitacora: form.descripcion,
    //   {
    //   idTipoPerfil: form.itemSelected.idTipoPerfil,
    //   idCatalogoPerfil: form.itemSelected.idCatalogoPerfil,
    //   nombrePerfil: form.itemSelected.descripcion
    // },
    remitente: {
      idUsuario: sessionStorage.uid
    },
    destinatarios: {
      destinatario: informe
    }
  }

  return (dispatch) => {

    dispatch(isLoading(true))

    return new ClientHttpRequest({
      service: 'api/bpm/informarBitGen',
      method: "POST",
      data: {...temp},
      headers: Object.assign({
        "Authorization": sessionStorage.access_token,
        "Bpm": sessionStorage.bpm_token,
        "uid": sessionStorage.uid
      })
    }).request().then(response => {
      dispatch(isLoading(false))
      return response.data
    }).catch(error => {
      dispatch(isLoading(false))
      dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
      throw error
    })
  }
}

export const clearContactData = () => {

  return (dispatch) => {

    dispatch({ type: ACTION_SEARCH_CONSULTA_PERFIL, Obj: [] })
    dispatch({ type: ACTION_SEARCH_CONSULTA_PERSONAL_INTERNO, Obj: [] })
    dispatch({ type: ACTION_SEARCH_CONSULTA_TIPO_BITACORA, Obj: [] })
    dispatch({ type: ACTION_SEARCH_CONSULTA_BITACORA, Obj: [] })
    dispatch({ type: ACTION_GET_BITACORA, Obj: {} })

  }
}



// WEBPACK FOOTER //
// ./src/modules/Blog/General/index.js